// eslint-disable-next-line import/prefer-default-export
export const durationToTime = (duration: number): string => {
  const secNum = parseInt(duration.toString(), 10)
  const hours = Math.floor(secNum / 3600)
  const minutes = Math.floor((secNum - (hours * 3600)) / 60)
  const seconds = secNum - (hours * 3600) - (minutes * 60)
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}
